// Text from a `{en, ar}` map as returned by the API (products, banners).

/** Localised text from a `{en, ar}` map (or a plain string); falls back to the other language. */
export const pickLocalized = (value, language = 'en') => {
  if (typeof value === 'string') return value.trim();
  if (!value || typeof value !== 'object') return '';
  const own = typeof value[language] === 'string' ? value[language].trim() : '';
  if (own) return own;
  for (const key of ['en', 'ar']) {
    if (typeof value[key] === 'string' && value[key].trim()) return value[key].trim();
  }
  return '';
};
